import { render, staticRenderFns } from "./DeleteWithConfirm.vue?vue&type=template&id=8a4b8a8e"
import script from "./DeleteWithConfirm.vue?vue&type=script&lang=js"
export * from "./DeleteWithConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports